/* eslint-disable react/require-default-props */
/* eslint-disable no-param-reassign */
import { useEffect, useMemo } from 'react';
import { EMPTY_ARRAY, EMPTY_MAP } from '@deephaven/utils';
import { useOnChange } from '@deephaven/react-hooks';
import IrisGridUtils from "./IrisGridUtils.js";
import { isPartitionedGridModel } from "./PartitionedGridModel.js";
import { isIrisGridTreeTableModel } from "./IrisGridTreeTableModel.js";
var COLUMN_BUFFER_PAGES = 1;
/**
 * React component to keep IrisGridModel in sync
 */
function IrisGridModelUpdater(_ref) {
  var model = _ref.model,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    filter = _ref.filter,
    formatter = _ref.formatter,
    columnAlignmentMap = _ref.columnAlignmentMap,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    sorts = _ref.sorts,
    customColumns = _ref.customColumns,
    movedColumns = _ref.movedColumns,
    hiddenColumns = _ref.hiddenColumns,
    alwaysFetchColumns = _ref.alwaysFetchColumns,
    _ref$rollupConfig = _ref.rollupConfig,
    rollupConfig = _ref$rollupConfig === void 0 ? null : _ref$rollupConfig,
    _ref$totalsConfig = _ref.totalsConfig,
    totalsConfig = _ref$totalsConfig === void 0 ? null : _ref$totalsConfig,
    _ref$selectDistinctCo = _ref.selectDistinctColumns,
    selectDistinctColumns = _ref$selectDistinctCo === void 0 ? EMPTY_ARRAY : _ref$selectDistinctCo,
    _ref$pendingRowCount = _ref.pendingRowCount,
    pendingRowCount = _ref$pendingRowCount === void 0 ? 0 : _ref$pendingRowCount,
    _ref$pendingDataMap = _ref.pendingDataMap,
    pendingDataMap = _ref$pendingDataMap === void 0 ? EMPTY_MAP : _ref$pendingDataMap,
    frozenColumns = _ref.frozenColumns,
    formatColumns = _ref.formatColumns,
    columnHeaderGroups = _ref.columnHeaderGroups,
    partitionConfig = _ref.partitionConfig,
    showExtraGroupColumn = _ref.showExtraGroupColumn;
  var isTotalsAvailable = model.isTotalsAvailable,
    isRollupAvailable = model.isRollupAvailable;
  // Check for showExtraGroupColumn before memoizing columns, since updating it will change the columns
  useOnChange(() => {
    if (isIrisGridTreeTableModel(model) && showExtraGroupColumn != null) {
      model.showExtraGroupColumn = showExtraGroupColumn;
    }
  }, [model, showExtraGroupColumn]);
  var columns = useMemo(() => IrisGridUtils.getModelViewportColumns(model.columns, left, right, movedColumns, hiddenColumns, alwaysFetchColumns, COLUMN_BUFFER_PAGES), [model.columns, left, right, movedColumns, hiddenColumns, alwaysFetchColumns]);
  useOnChange(function updateFilter() {
    model.filter = filter;
  }, [model, filter]);
  useOnChange(function updateSorts() {
    var sortsForModel = [...sorts];
    if (reverse) {
      sortsForModel.push(model.dh.Table.reverse());
    }
    model.sort = sortsForModel;
  }, [model, sorts, reverse]);
  useOnChange(function updateFormatter() {
    model.formatter = formatter;
  }, [model, formatter]);
  useOnChange(function updateColumnAlignmentMap() {
    model.columnAlignmentMap = columnAlignmentMap;
  }, [model, columnAlignmentMap]);
  useOnChange(function updateCustomColumns() {
    if (model.isCustomColumnsAvailable) {
      model.customColumns = customColumns;
    }
  }, [model, customColumns]);
  useOnChange(function updateFormatColumns() {
    if (model.isFormatColumnsAvailable) {
      model.formatColumns = formatColumns;
    }
  }, [model, formatColumns]);
  useOnChange(function updateViewport() {
    model.setViewport(top, bottom, columns);
  }, [model, top, bottom, columns]);
  useOnChange(function updateRollupCOnfig() {
    if (isRollupAvailable) {
      model.rollupConfig = rollupConfig;
    }
  }, [model, isRollupAvailable, rollupConfig]);
  useOnChange(function updateSelectDistinctColumns() {
    if (model.isSelectDistinctAvailable) {
      model.selectDistinctColumns = selectDistinctColumns;
    }
  }, [model, selectDistinctColumns]);
  useOnChange(function updateTotalsConfig() {
    if (isTotalsAvailable) {
      model.totalsConfig = totalsConfig;
    }
  }, [model, isTotalsAvailable, totalsConfig]);
  useOnChange(function updateColumnHeaderGroups() {
    model.columnHeaderGroups = columnHeaderGroups;
  }, [model, columnHeaderGroups]);
  useOnChange(function updatePartitionConfig() {
    if (partitionConfig && isPartitionedGridModel(model)) {
      model.partitionConfig = partitionConfig;
    }
  }, [model, partitionConfig]);
  // These setters are wrapped in useEffect instead of useOnChange because they emit an event
  // that potentially causes side effects, violating the rule that render should be a pure function.
  useEffect(function updateFrozenColumns() {
    if (frozenColumns) {
      model.updateFrozenColumns(frozenColumns);
    }
  }, [model, frozenColumns]);
  useEffect(function updatePendingRowCount() {
    model.pendingRowCount = pendingRowCount;
  }, [model, pendingRowCount]);
  useEffect(function updatePendingDataMap() {
    model.pendingDataMap = pendingDataMap;
  }, [model, pendingDataMap]);
  return null;
}
IrisGridModelUpdater.displayName = 'IrisGridModelUpdater';
export default IrisGridModelUpdater;
//# sourceMappingURL=IrisGridModelUpdater.js.map